<ngb-alert *ngIf="message!=undefined" [type]="message.type" (closed)="closeAlert()">{{message.text}}</ngb-alert>
